import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import * as BsXLg from "react-icons/bs";
import * as BiBookContent from 'react-icons/bi';
import * as BiGroup from 'react-icons/bi';
import * as IoIosArrowBack from "react-icons/io";

import './Createbtn.css';
import CreateBoard from './CreateBoard';
import CreateAccordian from './CreateAccordian'




const Createbtn = ({ setCreatbtn }) => {

  const [ShowCreate, setShowCreate] = useState(false)
  const [ShowPage, setShowPage] = useState(false)




  return (
    <div className="modalBackgroundss">
      <div className="modalContainerss">

        <div className='acuntdivss'>
          <div className="icondiviconss" >

            {ShowCreate != false &&
              <IoIosArrowBack.IoIosArrowBack style={{ cursor: 'pointer' }} onClick={() => setShowCreate(false)} />}
          </div>
          <span>Create</span>

          <Link className="iconcolorchngess" onClick={() => setCreatbtn(false)} >
            <BsXLg.BsXLg />
          </Link>
        </div>

        <hr style={{ width: "260px", border: '1px solid darkgray', marginTop: "0.5rem", marginLeft: "-6px" }} />

        {!ShowPage &&
          <>
            <div className="diviconschngss" onClick={() => { setShowCreate(true) }}>

              <div className="diviconslrgss" > <BiBookContent.BiBookContent /></div>
              <span className="divflexdivallss" >Create Boards</span>
              {
                ShowCreate == true && <>
                  <CreateBoard setCreatbtn={setCreatbtn} /></>
              }
            </div>
            <div className="divanotherdivtextss">
              <span className="divanotherdivtextss"> A board is made up of cards ordered on list.Use it to manage
                projects, track information,or  organize anything .</span>
            </div>

            <div className="diviconschngsse" onClick={() => setShowPage(true)}>

              <div className="diviconslrgss"> <BiBookContent.BiBookContent /></div>
              <span className="divflexdivallss">Start with a template</span>
            </div>

            <div className="divanotherdivtextss">
              <span className="divanotherdivtextss"> Get started faster with a board template .</span>
            </div>
          </>
        }
        {
          ShowPage == true && <><CreateAccordian setCreatbtn={setCreatbtn} /></>
        }
        {!ShowPage &&
          <>
            <div className="diviconschngsse">

              <div className="diviconslrgss"> <BiGroup.BiGroup /></div>
              <span className="divflexdivallss">Create Workspace</span>
            </div>
            <div className="divanotherdivtextss">
              <span className="divanotherdivtextss">A workspace is a group of boards and people.
                Use it to organize your company, side hustle.family,or Friends.</span>

            </div>
          </>
        }

      </div>
    </div>

  )
}

export default Createbtn